<div class="smart-color-inout">
  <span class="numeration">{{ lineNumber }}</span>

  <span class="enter-color-input-container">
    <input
      class="uppercase enter"
      #enterColorString
      autocomplete="off"
      placeholder="Enter color"
      type="text"
      [(ngModel)]="value"
      (focus)="onEnterColor()"
      (focusout)="onSaveColor(value)"
    />
    <small *ngIf="invalidColorString" class="solid-color-info-message"
      >Invalid hex code</small
    >
  </span>
  <input
    class="uppercase drag"
    spellcheck="false"
    #dragColor
    type="text"
    [colorPicker]="value"
    [cpAlphaChannel]="'disabled'"
    [cpDisableInput]="true"
    (colorPickerChange)="value = $event"
    cpWidth="180px"
    cpWHeight="180px"
  />
</div>
